<div><router-outlet></router-outlet>
    <div style="width: 98%;height: 0px; border: '2px solid red'; z-index: 999999; position: fixed; bottom: 0; right: 0;" class="example-boundary">
        <div id="container" style="z-index: 9999;position: fixed; bottom: 20px; right: 20px;" cdkDrag
        (cdkDragStarted)="onDragStart($event)" (cdkDragEnded)="onDragEnd($event)" cdkDragBoundary=".example-boundary"></div>
    </div>
</div>